import _ from 'lodash'
import Login from '../views/Login.vue'
import store from '../store';

export const routersConfig = [
  {
    path: '/',
    redirect: { name: 'login' }
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      index: 1
    },
    beforeEnter: (to, from, next) => {
      const redirectUrl = _.get(to, 'query.redirect_url');
      if (redirectUrl) {
        store.commit('login/setRedirectUrl', redirectUrl);
      }
      next();
    },
    component: Login
  },
  {
    path: '/logout',
    name: 'logout',
    beforeEnter: (to, from, next) => {
      const redirectUrl = _.get(to, 'query.redirect_url');
      if (redirectUrl) {
        store.commit('login/setRedirectUrl', redirectUrl);
      }
      return store.dispatch('login/logout').then(res => {
        next({ name: 'login' });
      }).catch(err => {
        next({ name: 'login' });
      });
    }
  },
  {
    path: '/verify',
    name: 'verify',
    meta: {
      index: 2
    },
    beforeEnter: (to, from, next) => {
      if (from.name === 'login') {
        next()
      } else {
        next({ name: 'login' })
      }
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Verify.vue')
  }
];
